import type { ElementTheme } from './light'
import { commonDark } from '../../_styles/common'

const elementDark: ElementTheme = {
  name: 'Element',
  common: commonDark
}

export default elementDark
